import { Box, Tooltip, Typography } from '@mui/material';
import TooltipContent from './TooltipContent';
import { sxConfig } from './calendarStyle';
import dayjs from 'dayjs';
import colorFinder from '../../utils/colorFinder';

const SimpleTaskEventContent = ({ eventInfo, resources }) => {
  const extendedProps = eventInfo.event.extendedProps;
  const status = extendedProps.status?.color;
  const projectName = resources.project.find((pr) => pr.projectId === extendedProps?.projectId)?.projectName;
  const title = eventInfo.event.title;

  const color = colorFinder(status);
  const textColor = color.textColor || '#000';

  return (
    <Tooltip
      arrow
      placement="top"
      title={<TooltipContent eventInfo={eventInfo} />}
      slotProps={{
        tooltip: {
          sx: sxConfig.tooltip,
        },
        arrow: { sx: sxConfig.tooltipArrow },
      }}
    >
      <Box
        sx={{
          ...sxConfig.eventBox,
          backgroundColor: color.colorBgCode,
          borderLeft: `3px solid ${textColor}`,
        }}
      >
        <Box>
          <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
            F: {title}
          </Typography>
        </Box>
        <Box>
          <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
            K: {dayjs(extendedProps.startDate).format('YYYY-MM-DD HH:mm')}
          </Typography>
        </Box>
        <Box>
          <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
            H: {dayjs(extendedProps.endDate).format('YYYY-MM-DD HH:mm')}
          </Typography>
        </Box>
        <Box>
          <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
            F: {extendedProps.responsiblePerson?.nickName}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SimpleTaskEventContent;
